import { AppointerDTO } from '@asd-stan/user/api/appointer/appointer.dto';
import { Appointer } from '@asd-stan/user/domain/appointer.entity';

export const makeAppointerFromAppointerDTO = (dto: AppointerDTO): Appointer => {
	return new Appointer({
		id: dto.id,
		name: dto.name,
	});
};
